// Module
var code = "<div> <div class=\"name\">{{ filter.field.display_name }}</div> <template v-if=\"editing == true\"> <text-field :value.sync=\"filter.value\" label=\"Value\"></text-field> </template> <template v-if=\"editing == false\"> {{ filter.field.display_name }} {{valueText}} </template> </div> ";
// Exports
export default code;